import React, { useState } from 'react';
import styles from './CreateConnectionModal.module.css';
import SecureInput from '../../ui/SecureInput/SecureInput';
import { Link as LinkIcon } from 'lucide-react';

interface CreateConnectionModalProps {
  onClose: () => void;
  onCreate: (connection: { id: string; connectionName: string; description: string; icon: string }) => void;
}

const CreateConnectionModal: React.FC<CreateConnectionModalProps> = ({ onClose, onCreate }) => {
  const [connectionName, setConnectionName] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('');

  const handleSubmit = () => {
    if (!connectionName || !description || !icon) {
      alert('Please fill in all fields.');
      return;
    }

    const newConnection = {
      id: Date.now().toString(), // Temporary ID generation
      connectionName,
      description,
      icon,
    };

    onCreate(newConnection);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>Create Connection</h2>
        <SecureInput
          fieldType="name"
          label="Name"
          value={connectionName}
          onChange={setConnectionName}
          required
        />
        <label>
          Description:
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>
        <SecureInput
          fieldType="url"
          label="Icon URL"
          icon={<LinkIcon size={16} />}
          value={icon}
          onChange={setIcon}
          required
        />
        <div className={styles.actions}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSubmit}>Create</button>
        </div>
      </div>
    </div>
  );
};

export default CreateConnectionModal;